export default "__VITE_ASSET__DLqSxIMK__"